import { mdiSpeedometer } from "@mdi/js";

const Nav = [
  {
    title: "Performances Web",
    icon: mdiSpeedometer,
    children: [
      {
        title: "CWV (Beta)",
        resource: "web_perf",
        action: "manage",
        children: [
          {
            title: "Performance des sites",
            to: "cwv-sites-performance",
            resource: "web_perf",
            action: "manage",
          },
          {
            title: "Performance en détail",
            to: "cwv-performance-breakdown",
            resource: "web_perf",
            action: "manage",
          },
          {
            title: "Changements de palier",
            to: "cwv-threshold-changes",
            resource: "web_perf",
            action: "manage",
          },
          {
            title: "Données consolidées par jour",
            to: "cwv-daily-data",
            resource: "web_perf",
            action: "manage",
          },
          {
            title: "Suivi des tickets",
            to: "cwv-issues",
            resource: "web_perf",
            action: "manage",
          },
        ],
      },
      {
        title: "Synthetic Monitoring",
        resource: "web_perf",
        action: "manage",
        children: [
          {
            title: "Synthetic Monitoring",
            to: "synthetic-monitoring-dashboard",
            resource: "web_perf",
            action: "manage",
          },
          {
            title: "Ajouter/Editer une URL",
            to: "synthetic-monitoring-add-edit",
            resource: "web_perf",
            action: "manage",
          },
          {
            title: "Liste des URLs",
            to: "synthetic-monitoring-list",
            resource: "web_perf",
            action: "manage",
          },
        ],
      },
    ],
  },
];

export default Nav;
